import { AdderTypes, dollarsToNum } from "@oneethos/shared"
import { ConsumerAppFormData } from "../pages/consumerApplicationForm"

export const usePpw = (formData: ConsumerAppFormData): {
  ppwPV: number
  ppwStorage: number
} => {
  const size = formData.systemSizeKW || 0
  const solarCost = dollarsToNum(formData.solarCost) || 0
  const ppwPV = size && solarCost ? (solarCost / (size * 1000)) : undefined
  const batteryTotalPrice = dollarsToNum(
    formData.adders?.find(a => a.description === AdderTypes.StoragePrice)?.amount
  )
  const ppwStorage = batteryTotalPrice && size ? (batteryTotalPrice / size / 1000) : undefined

  return { ppwPV, ppwStorage }
}
